module.exports = __webpack_public_path__ + "img/psi_img.4d84e646.png";